webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "94YA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ImAQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LA/e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/Footer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Footer = ({
  computed: {
    copyMsg: function copyMsg() {
      var d = new Date();
      return '© ' + d.getFullYear() + ' ' + this.$store.getters.settings.client.name + ' All rights reserved.';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-593d7ace","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Footer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$route.name==='Login' || _vm.$route.name==='Signup'?'login-screens':''},[_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-container"},[_c('span',{staticClass:"footer-text t-text-color"},[_vm._v(_vm._s(_vm.copyMsg))]),_vm._v(" "),_c('div',{staticClass:"footer-right-info"},[_c('a',{staticClass:"footer-text t-text-color",attrs:{"href":_vm.$store.getters.settings.client.powered_by_link,"target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.$store.getters.settings.client.powered_by_label)}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var layout_Footer = (esExports);
// CONCATENATED MODULE: ./src/components/layout/Footer.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Footer,
  layout_Footer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_layout_Footer = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/Header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Header = ({
  computed: {
    switchPath: function switchPath() {
      return '/ar' + this.$route.path;
    }
  },
  methods: {
    logout: function logout() {
      this.$auth.logout({
        redirect: { name: 'Login' }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196c17d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Header.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-header-component"},[_c('div',{staticClass:"header__title t-text-color"},[_vm._v(_vm._s(_vm.$store.getters.settings.appName))]),_vm._v(" "),_c('nav',[_c('ul',{staticClass:"header-menu"},[_c('li',[_c('div',{staticClass:"header-menu__item"},[_vm._v(_vm._s(_vm.$auth.user().name))])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"header-menu__item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_vm._v("Logout")])]),_vm._v(" "),(_vm.$store.getters.settings.client.bilingual)?_c('li',[_c('a',{staticClass:"header-menu__item language-toggle",attrs:{"href":_vm.switchPath}},[_vm._v("عربي")])]):_vm._e()])])])}
var Header_staticRenderFns = []
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var layout_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/components/layout/Header.vue
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = null
/* scopeId */
var Header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  Header,
  layout_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var components_layout_Header = (Header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/MenuSection.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MenuSection = ({
  props: ['section', 'index'],
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    isSelectedCheck: function isSelectedCheck(subSectionId) {
      if (this.$route.name === 'Section' || this.$route.name === 'SubSection') {
        if (typeof subSectionId !== 'undefined') {
          return this.$route.params.slug2 === subSectionId;
        }
        return this.$route.params.slug === this.section.slug;
      }
      return false;
    }
  },
  created: function created() {
    this.isOpen = this.isSelected;
  },

  computed: {
    selectedSectionId: function selectedSectionId() {
      return this.$store.getters.selectedSectionId;
    },
    isSelected: function isSelected() {
      if (this.$route.name === 'Section' || this.$route.name === 'SubSection') {
        // if (typeof subSectionId !== 'undefined') {
        //   return (this.$route.params.slug2 === subSectionId)
        // }
        return this.$route.params.slug === this.section.slug;
      }
      return false;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.isOpen = this.isSelected;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-031c2f46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MenuSection.vue
var MenuSection_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.index>0)?_c('li',{staticClass:"main-menu__item",class:{'main-menu__item--selected':_vm.isSelected}},[(_vm.section.subSections.length > 0)?_c('a',{staticClass:"main-menu__item--link",class:{'selected-item':_vm.isSelected},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.isOpen = !_vm.isOpen}}},[_vm._v("\n    "+_vm._s(_vm.section.title)),(_vm.section.subSections.length > 0)?_c('span',{staticClass:"menu-arrow",class:{'js-menu-arrow--flip':_vm.isOpen}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.section.subSections.length === 0)?_c('router-link',{staticClass:"main-menu__item--link",class:{'selected-item':_vm.selectedSectionId === _vm.section.id},attrs:{"active-class":"selected-item","to":'/'+_vm.section.slug}},[_vm._v("\n    "+_vm._s(_vm.section.title)),(_vm.section.subSections.length > 0)?_c('span',{staticClass:"menu-arrow",class:{'js-menu-arrow--flip':_vm.isOpen}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"accordion"}},[(_vm.section.subSections.length > 0 && _vm.isOpen)?_c('ul',{staticClass:"sub-menu"},_vm._l((_vm.section.subSections),function(subSection){return _c('li',[_c('router-link',{staticClass:"sub-menu__item",class:{'selected-item':_vm.isSelectedCheck(subSection.slug)},attrs:{"to":'/'+_vm.section.slug+'/'+subSection.slug}},[_vm._v("\n          "+_vm._s(subSection.title)+"\n        ")])],1)}),0):_vm._e()])],1):_vm._e()}
var MenuSection_staticRenderFns = []
var MenuSection_esExports = { render: MenuSection_render, staticRenderFns: MenuSection_staticRenderFns }
/* harmony default export */ var layout_MenuSection = (MenuSection_esExports);
// CONCATENATED MODULE: ./src/components/layout/MenuSection.vue
function injectStyle (ssrContext) {
  __webpack_require__("OTzN")
}
var MenuSection_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MenuSection___vue_template_functional__ = false
/* styles */
var MenuSection___vue_styles__ = injectStyle
/* scopeId */
var MenuSection___vue_scopeId__ = "data-v-031c2f46"
/* moduleIdentifier (server only) */
var MenuSection___vue_module_identifier__ = null
var MenuSection_Component = MenuSection_normalizeComponent(
  MenuSection,
  layout_MenuSection,
  MenuSection___vue_template_functional__,
  MenuSection___vue_styles__,
  MenuSection___vue_scopeId__,
  MenuSection___vue_module_identifier__
)

/* harmony default export */ var components_layout_MenuSection = (MenuSection_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/Menu.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Menu = ({
  created: function created() {
    this.getSections();
  },

  components: {
    menuSection: components_layout_MenuSection
  },
  data: function data() {
    return {
      home: {}
    };
  },

  methods: {
    getSections: function getSections() {
      var _this = this;

      this.$store.dispatch('setIsLoaded', false);
      this.axios.get('/sections').then(function (response) {
        _this.$store.dispatch('setSections', response.data.sections);
        _this.$store.dispatch('setIsLoaded', true);
        _this.home = response.data.sections[0];
      }).catch(function (error) {
        console.log(error);
      });
    },
    openSubSection: function openSubSection(section) {}
  },
  computed: {
    //      home () {
    //        return this.$store.getters.sections[0]
    //      },
    isLoaded: function isLoaded() {
      return this.$store.getters.isLoaded;
    },
    sections: function sections() {
      return this.$store.getters.sections;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42e8ca62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Menu.vue
var Menu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('aside',[_c('div',{staticClass:"side-logo"},[_c('router-link',{attrs:{"to":{name:'Home'}}},[_c('img',{attrs:{"srcset":_vm.$store.getters.settings.client.logo_4x +' 2x',"src":_vm.$store.getters.settings.client.logo,"alt":""}})])],1),_vm._v(" "),_c('nav',{staticClass:"side-nav"},[_c('ul',{staticClass:"main-menu"},[_vm._l((_vm.sections),function(section,index){return _c('menu-section',{key:section.id,attrs:{"index":index,"section":section}})}),_vm._v(" "),_c('li',{staticClass:"main-menu__item",class:{'main-menu__item--selected':_vm.$route.name==='Contact'}},[_c('router-link',{staticClass:"main-menu__item--link",class:{'selected-item':_vm.$route.name==='Contact'},attrs:{"to":{name:'Contact'}}},[_vm._v("\n          Contact Information\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"main-menu__item",class:{'main-menu__item--selected':_vm.$route.name==='Download'}},[_c('router-link',{staticClass:"main-menu__item--link",class:{'selected-item':_vm.$route.name==='Download'},attrs:{"to":{name:'Download'}}},[_vm._v("\n          Download Center\n        ")])],1)],2)]),_vm._v(" "),(_vm.isLoaded)?_c('div',{staticClass:"menu-border"}):_vm._e()]):_vm._e()}
var Menu_staticRenderFns = []
var Menu_esExports = { render: Menu_render, staticRenderFns: Menu_staticRenderFns }
/* harmony default export */ var layout_Menu = (Menu_esExports);
// CONCATENATED MODULE: ./src/components/layout/Menu.vue
function Menu_injectStyle (ssrContext) {
  __webpack_require__("mUAz")
}
var Menu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Menu___vue_template_functional__ = false
/* styles */
var Menu___vue_styles__ = Menu_injectStyle
/* scopeId */
var Menu___vue_scopeId__ = "data-v-42e8ca62"
/* moduleIdentifier (server only) */
var Menu___vue_module_identifier__ = null
var Menu_Component = Menu_normalizeComponent(
  Menu,
  layout_Menu,
  Menu___vue_template_functional__,
  Menu___vue_styles__,
  Menu___vue_scopeId__,
  Menu___vue_module_identifier__
)

/* harmony default export */ var components_layout_Menu = (Menu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var App = ({
  name: 'app',
  components: {
    appHeader: components_layout_Header,
    appFooter: components_layout_Footer,
    appMenu: components_layout_Menu
  },
  data: function data() {
    return {
      backToTopVisible: false
    };
  },

  computed: {
    isLoaded: function isLoaded() {
      return this.$store.getters.isLoaded;
    }
  },
  methods: {
    backToTop: function backToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    catchScroll: function catchScroll() {
      this.backToTopVisible = window.pageYOffset > 100;
    }
  },
  mounted: function mounted() {
    window.smoothscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener('scroll', this.catchScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.catchScroll);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06578129","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.$auth.ready())?_c('div',[(_vm.$auth.check())?_c('main',{staticClass:"main-content",attrs:{"role":"main"}},[_c('app-menu'),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.backToTopVisible)?_c('a',{staticClass:"back-top",attrs:{"id":"back-top","href":"#top"},on:{"click":function($event){$event.preventDefault();return _vm.backToTop.apply(null, arguments)}}}):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.$auth.check())?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('app-footer'):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('vue-progress-bar')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("94YA")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-progressbar/dist/vue-progressbar.js
var vue_progressbar = __webpack_require__("zYko");
var vue_progressbar_default = /*#__PURE__*/__webpack_require__.n(vue_progressbar);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/ContentRow.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ContentRow = ({
  props: ['row', 'content', 'index'],
  mounted: function mounted() {},
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    type: function type() {
      return this.row.type;
    }
  },
  methods: {
    fileExec: function fileExec(filename) {
      return filename.split('.').pop().split(/\#|\?/)[0];
    },
    isAttachmentNext: function isAttachmentNext() {
      if (typeof this.content !== 'undefined' && typeof this.content[this.index + 1] !== 'undefined' && this.content[this.index + 1].type === 14) {
        return true;
      }
      return false;
    },
    download: function download(folder, Name) {
      var _this = this;

      if (this.loading === false) {
        // var windowRef = window.open()
        this.loading = folder.id;
        this.axios.get('/downloads/download?id=' + folder.id, {}).then(function (response) {
          if (response.data.url) {
            _this.runDownload(response.data.url, Name);
          }
        });
      }
    },
    runDownload: function runDownload(url, Name) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.axios.get(url, { responseType: 'blob' }).then(function (response) {
                  var blob = new Blob([response.data], { type: 'application/zip' });
                  var link = document.createElement('a');
                  link.href = URL.createObjectURL(blob);
                  link.download = Name;
                  link.click();
                  URL.revokeObjectURL(link.href);
                  _this2.loading = false;
                }).then(function () {
                  _this2.loading = false;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec435ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ContentRow.vue
var ContentRow_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAttachmentNext())?_c('a',{attrs:{"id":'g-'+_vm.content[_vm.index+1].id}}):_vm._e(),_vm._v(" "),(_vm.type === 1)?_c('div',{staticClass:"c-introduction"},[_c('header',{staticClass:"main-section-title"},[_c('h1',[_vm._v("\n        "+_vm._s(_vm.row.title_1)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"body-text-wrapper"},[_c('div',{staticClass:"body-text body-text--large",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])]):_vm._e(),_vm._v(" "),(_vm.type === 2)?_c('div',{staticClass:"section-block c-sub-section"},[_c('a',{attrs:{"id":'sub-'+_vm.row.id}}),_vm._v(" "),_c('div',{staticClass:"sub-section__title"},[_c('h2',[_vm._v("\n        "+_vm._s(_vm.row.title_1)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"body-text-wrapper"},[_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])]):_vm._e(),_vm._v(" "),(_vm.type === 3)?_c('div',{staticClass:"section-block c-main-title"},[_c('div',{staticClass:"main-title__title"},[_c('h3',[_vm._v("\n        "+_vm._s(_vm.row.title_1)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"body-text-wrapper"},[_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])]):_vm._e(),_vm._v(" "),(_vm.type === 4)?_c('div',{staticClass:"section-block c-sub-title"},[_c('div',{staticClass:"sub-title__title"},[_c('h4',[_vm._v("\n        "+_vm._s(_vm.row.title_1)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"body-text-wrapper"},[_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])]):_vm._e(),_vm._v(" "),(_vm.type === 5)?_c('div',{staticClass:"c-divider"},[_c('div',{staticClass:"c-divider__line"})]):_vm._e(),_vm._v(" "),(_vm.type === 6)?_c('div',{staticClass:"section-block c-full-image"},[(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_1}})]):_vm._e(),_vm._v(" "),(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_1}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption image-caption--full"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v("\n          "+_vm._s(_vm.row.title_1)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])])]):_vm._e(),_vm._v(" "),(_vm.type === 7)?_c('div',{staticClass:"section-block c-half-col-grid"},[_c('ul',{staticClass:"col-grid-50"},[_c('li',{staticClass:"col-grid-50__item"},[(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_1}})]):_vm._e(),_vm._v(" "),(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_1}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_1))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])])]),_vm._v(" "),_c('li',{staticClass:"col-grid-50__item"},[(_vm.row.image_2 && _vm.fileExec(_vm.row.image_2)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_2}})]):_vm._e(),_vm._v(" "),(_vm.row.image_2 && _vm.fileExec(_vm.row.image_2)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_2}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_2))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_2)}})])])])])]):_vm._e(),_vm._v(" "),(_vm.type === 8)?_c('div',{staticClass:"section-block c-two-one-grid"},[_c('ul',{staticClass:"col-grid-two-one"},[_c('li',{staticClass:"col-grid-two-one__item col-grid-two-one__item--65"},[(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_1}})]):_vm._e(),_vm._v(" "),(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_1}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_1))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])])]),_vm._v(" "),_c('li',{staticClass:"col-grid-two-one__item col-grid-two-one__item--35"},[(_vm.row.image_2 && _vm.fileExec(_vm.row.image_2)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_2}})]):_vm._e(),_vm._v(" "),(_vm.row.image_2 && _vm.fileExec(_vm.row.image_2)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_2}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_2))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_2)}})])])])])]):_vm._e(),_vm._v(" "),(_vm.type === 9)?_c('div',{staticClass:"section-block c-three-col-grid"},[_c('ul',{staticClass:"col-grid-33"},[_c('li',{staticClass:"col-grid-33__item"},[(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_1}})]):_vm._e(),_vm._v(" "),(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_1}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_1))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])])]),_vm._v(" "),_c('li',{staticClass:"col-grid-33__item"},[(_vm.row.image_2 && _vm.fileExec(_vm.row.image_2)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_2}})]):_vm._e(),_vm._v(" "),(_vm.row.image_2 && _vm.fileExec(_vm.row.image_2)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_2}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_2))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_2)}})])])]),_vm._v(" "),_c('li',{staticClass:"col-grid-33__item"},[(_vm.row.image_3 && _vm.fileExec(_vm.row.image_3)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_3}})]):_vm._e(),_vm._v(" "),(_vm.row.image_3 && _vm.fileExec(_vm.row.image_3)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_3}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_3))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_3)}})])])])])]):_vm._e(),_vm._v(" "),(_vm.type === 10)?_c('div',{staticClass:"section-block c-four-col-grid"},[_c('ul',{staticClass:"col-grid-25"},[_c('li',{staticClass:"col-grid-25__item"},[(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_1}})]):_vm._e(),_vm._v(" "),(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_1}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_1))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])])]),_vm._v(" "),_c('li',{staticClass:"col-grid-25__item"},[(_vm.row.image_2 && _vm.fileExec(_vm.row.image_2)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_2}})]):_vm._e(),_vm._v(" "),(_vm.row.image_2 && _vm.fileExec(_vm.row.image_2)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_2}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_2))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_2)}})])])]),_vm._v(" "),_c('li',{staticClass:"col-grid-25__item"},[(_vm.row.image_3 && _vm.fileExec(_vm.row.image_3)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_3}})]):_vm._e(),_vm._v(" "),(_vm.row.image_3 && _vm.fileExec(_vm.row.image_3)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_3}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_3))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_3)}})])])]),_vm._v(" "),_c('li',{staticClass:"col-grid-25__item"},[(_vm.row.image_4 && _vm.fileExec(_vm.row.image_4)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_4}})]):_vm._e(),_vm._v(" "),(_vm.row.image_4 && _vm.fileExec(_vm.row.image_4)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_4}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-caption"},[_c('div',{staticClass:"image-caption__text"},[_c('span',{staticClass:"caption-title"},[_vm._v(_vm._s(_vm.row.title_4))]),_vm._v(" "),_c('span',{staticClass:"image-caption__text_inline",domProps:{"innerHTML":_vm._s(_vm.row.description_4)}})])])])])]):_vm._e(),_vm._v(" "),(_vm.type === 11)?_c('div',{staticClass:"section-block c-information-block"},[_c('div',{staticClass:"body-text-wrapper"},[_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])]):_vm._e(),_vm._v(" "),(_vm.type === 12)?_c('div',{staticClass:"section-block c-colors"},[_c('ul',{staticClass:"colors-list"},_vm._l((8),function(i){return (_vm.row['color_'+ i +'_hex'])?_c('li',{staticClass:"colors-list__item"},[_c('div',{staticClass:"color-circle",style:({backgroundColor:_vm.row['color_'+ i +'_hex']})}),_vm._v(" "),_c('div',{staticClass:"color-info"},[(_vm.row['color_'+ i +'_hex'])?_c('span',[_c('strong',[_vm._v("HEX")]),_vm._v(" "+_vm._s(_vm.row['color_' + i + '_hex']))]):_vm._e(),_vm._v(" "),(_vm.row['color_'+ i +'_c'])?_c('span',[_c('strong',[_vm._v("C")]),_vm._v(" "+_vm._s(_vm.row['color_' + i + '_c'])+" "),_c('strong',[_vm._v("M")]),_vm._v(" "+_vm._s(_vm.row['color_' + i + '_m'])+" "),_c('strong',[_vm._v("Y")]),_vm._v(" "+_vm._s(_vm.row['color_' + i + '_y'])+" "),_c('strong',[_vm._v("K")]),_vm._v(" "+_vm._s(_vm.row['color_' + i + '_k'])+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.row['color_'+ i +'_pantone'])?_c('span',[_c('strong',[_vm._v("PANTONE")]),_vm._v(" "+_vm._s(_vm.row['color_' + i + '_pantone']))]):_vm._e()])]):_vm._e()}),0)]):_vm._e(),_vm._v(" "),(_vm.type === 13)?_c('div',{staticClass:"section-block c-two-col-text"},[_c('ul',{staticClass:"two-text-grid"},[_c('li',{staticClass:"two-text-grid__item"},[_c('div',{staticClass:"sub-title__title"},[_c('h4',[_vm._v(_vm._s(_vm.row.title_1))])]),_vm._v(" "),_c('div',{staticClass:"body-text-wrapper"},[_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])]),_vm._v(" "),_c('li',{staticClass:"two-text-grid__item"},[_c('div',{staticClass:"sub-title__title"},[_c('h4',[_vm._v(_vm._s(_vm.row.title_2))])]),_vm._v(" "),_c('div',{staticClass:"body-text-wrapper"},[_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_2)}})])])])]):_vm._e(),_vm._v(" "),(_vm.type === 14)?_c('div',{staticClass:"section-block c-full-image"},[_c('div',{staticClass:"section-block-download"},[(_vm.row.folder.zip_file)?_c('a',{staticClass:"t-text-color",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.download(_vm.row.folder,_vm.row.folder.name)}}},[_vm._v("Download related assets\n        "),(_vm.loading === _vm.row.folder.id)?_c('div',{staticClass:"loader"}):_c('span',{staticClass:"download-btn"})]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.type === 15)?_c('div',{staticClass:"section-block widget",class:_vm.row.icon+'-widget'},[_c('i',{staticClass:"widget-icon",class:'widget-icon--'+_vm.row.icon}),_vm._v(" "),_c('div',{staticClass:"body-text-wrapper"},[_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_5)}})])]):_vm._e(),_vm._v(" "),(_vm.type === 16)?_c('div',{staticClass:"section-block c-image-text"},[_c('ul',{staticClass:"col-grid-50"},[_c('li',{staticClass:"col-grid-50__item"},[(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_1}})]):_vm._e(),_vm._v(" "),(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_1}}):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"col-grid-50__item"},[_c('div',{staticClass:"body-title"},[_c('h4',[_vm._v(_vm._s(_vm.row.title_1))])]),_vm._v(" "),_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])])]):_vm._e(),_vm._v(" "),(_vm.type === 17)?_c('div',{staticClass:"section-block c-image-text"},[_c('ul',{staticClass:"col-grid-50"},[_c('li',{staticClass:"col-grid-50__item"},[_c('div',{staticClass:"body-title"},[_c('h4',[_vm._v(_vm._s(_vm.row.title_1))])]),_vm._v(" "),_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})]),_vm._v(" "),_c('li',{staticClass:"col-grid-50__item"},[(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_1}})]):_vm._e(),_vm._v(" "),(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_1}}):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.type === 18)?_c('div',{staticClass:"section-block c-large-image-text"},[_c('ul',{staticClass:"col-grid-two-one"},[_c('li',{staticClass:"col-grid-two-one__item col-grid-two-one__item--65"},[(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_1}})]):_vm._e(),_vm._v(" "),(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_1}}):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"col-grid-two-one__item col-grid-two-one__item--35"},[_c('div',{staticClass:"body-title"},[_c('h4',[_vm._v(_vm._s(_vm.row.title_1))])]),_vm._v(" "),_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})])])]):_vm._e(),_vm._v(" "),(_vm.type === 19)?_c('div',{staticClass:"section-block c-large-image-text"},[_c('ul',{staticClass:"col-grid-two-one"},[_c('li',{staticClass:"col-grid-two-one__item col-grid-two-one__item--35"},[_c('div',{staticClass:"body-title"},[_c('h4',[_vm._v(_vm._s(_vm.row.title_1))])]),_vm._v(" "),_c('div',{staticClass:"body-text body-text--small",domProps:{"innerHTML":_vm._s(_vm.row.description_1)}})]),_vm._v(" "),_c('li',{staticClass:"col-grid-two-one__item col-grid-two-one__item--65"},[(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)==='mp4')?_c('video',{attrs:{"controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.row.image_1}})]):_vm._e(),_vm._v(" "),(_vm.row.image_1 && _vm.fileExec(_vm.row.image_1)!=='mp4')?_c('img',{attrs:{"src":_vm.row.image_1}}):_vm._e()])])]):_vm._e()])}
var ContentRow_staticRenderFns = []
var ContentRow_esExports = { render: ContentRow_render, staticRenderFns: ContentRow_staticRenderFns }
/* harmony default export */ var pages_ContentRow = (ContentRow_esExports);
// CONCATENATED MODULE: ./src/components/pages/ContentRow.vue
var ContentRow_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentRow___vue_template_functional__ = false
/* styles */
var ContentRow___vue_styles__ = null
/* scopeId */
var ContentRow___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentRow___vue_module_identifier__ = null
var ContentRow_Component = ContentRow_normalizeComponent(
  ContentRow,
  pages_ContentRow,
  ContentRow___vue_template_functional__,
  ContentRow___vue_styles__,
  ContentRow___vue_scopeId__,
  ContentRow___vue_module_identifier__
)

/* harmony default export */ var components_pages_ContentRow = (ContentRow_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Home = ({
  computed: {
    homeContent: function homeContent() {
      return this.$store.getters.sections[0].content;
    }
  },
  components: {
    ContentRow: components_pages_ContentRow,
    appHeader: components_layout_Header
  },
  created: function created() {},

  methods: {
    logout: function logout() {
      this.$auth.logout({
        redirect: { name: 'Login' }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbca6c92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.isLoaded)?_c('section',{staticClass:"website-section content-wrapper index-content"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"hero",style:({backgroundImage:'url(' + _vm.$store.getters.settings.client.header_image + ')'})},[_c('div',{staticClass:"hero-wrapper"},[_c('div',{staticClass:"hero-title"},[_vm._v("Introducing "+_vm._s(_vm.$store.getters.settings.client.name))]),_vm._v(" "),_c('div',{staticClass:"hero-desc"},[_c('p',[_vm._v(_vm._s(_vm.$store.getters.settings.client.slogan))])])])]),_vm._v(" "),_vm._l((_vm.homeContent),function(row){return (_vm.$store.getters.isLoaded)?_c('content-row',{key:row.id,attrs:{"row":row}}):_vm._e()})],2):_vm._e()}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var pages_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/pages/Home.vue
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = null
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  pages_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var components_pages_Home = (Home_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var validators = __webpack_require__("+cKO");
var validators_default = /*#__PURE__*/__webpack_require__.n(validators);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/auth/Login.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Login = ({
  computed: {
    switchPath: function switchPath() {
      return '/ar' + this.$route.path;
    }
  },
  data: function data() {
    return {
      showForgotModal: false,
      data: {
        body: {
          login: '',
          password: ''
        },
        rememberMe: true,
        fetchUser: false
      },
      forgetData: {
        email: ''
      },
      errorText: null,
      forgotErrorText: null,
      forgotSuccessText: null
    };
  },

  validations: {
    data: {
      body: {
        password: {
          required: validators["required"]
        },
        login: {
          required: validators["required"],
          email: validators["email"]
        }
      }
    },
    forgetData: {
      email: {
        required: validators["required"],
        email: validators["email"]
      }
    }
  },
  created: function created() {
    this.$store.dispatch('setIsLoaded', true);
    document.title = this.$store.getters.settings.appName;
  },

  filters: {
    json: function json(value) {
      return stringify_default()(value, null, 2);
    }
  },
  methods: {
    resetSubmit: function resetSubmit() {
      var _this = this;

      this.forgotErrorText = '';
      this.forgotSuccessText = '';
      this.$v.forgetData.$touch();
      if (!this.$v.forgetData.$invalid) {
        var qs = __webpack_require__("mw3O");
        this.axios.post('/auth/forgot-password', qs.stringify(this.forgetData)).then(function (response) {
          if (response.data.success === 'success') {
            _this.forgotSuccessText = 'An email has been sent with instructions for resetting your password';
            _this.forgetData = {
              name: ''
            };
            _this.$v.forgetData.$touch();
            _this.$v.forgetData.$reset();
          } else {
            _this.forgotErrorText = response.data.errors[0];
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    loginSubmit: function loginSubmit() {
      this.errorText = '';
      this.$v.data.$touch();
      if (!this.$v.data.$invalid) {
        var redirect = this.$auth.redirect();
        var qs = __webpack_require__("mw3O");
        this.$auth.login({
          data: qs.stringify(this.data.body), // Vue-resource
          rememberMe: this.data.rememberMe,
          redirect: {
            name: redirect ? redirect.from.name : 'Home',
            params: redirect ? redirect.from.params : {},
            hash: redirect ? redirect.from.hash : ''
          },
          fetchUser: this.data.fetchUser,
          success: function success(resp) {
            if (resp.data.success === 'error') {
              this.errorText = 'Invalid login or password';
            } else {
              this.$auth.fetch();
            }
          },
          error: function error(res) {
            this.errorText = 'Invalid login or password';
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e85cae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters.isLoaded)?_c('header',{staticClass:"login-header"},[_c('div',{staticClass:"logo"},[(_vm.$store.getters.settings.client.logo_2x)?_c('img',{attrs:{"src":_vm.$store.getters.settings.client.logo_2x,"srcset":_vm.$store.getters.settings.client.logo_4x +' 2x',"alt":"logo"}}):_vm._e()]),_vm._v(" "),(_vm.$store.getters.settings.client.bilingual)?_c('a',{staticClass:"language-toggle--overlay",attrs:{"href":_vm.switchPath}},[_vm._v("عربي")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('main',{staticClass:"intro-pages-content",attrs:{"role":"main"}},[_c('section',{staticClass:"website-section website-form"},[_c('div',{staticClass:"container container--small"},[_c('header',[_c('h1',[_vm._v(_vm._s(_vm.$store.getters.settings.appName))])]),_vm._v(" "),_c('form',{staticClass:"form-wrapper",on:{"submit":function($event){$event.preventDefault();return _vm.loginSubmit()}}},[_c('fieldset',[_c('legend',{staticClass:"legend-title"},[_vm._v("Member Login")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.login),expression:"data.body.login"}],staticClass:"form-input",class:{'is-invalid':_vm.$v.data.body.login.$error},attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.data.body.login)},on:{"blur":function($event){return _vm.$v.data.body.login.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "login", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.password),expression:"data.body.password"}],staticClass:"form-input",class:{'is-invalid':_vm.$v.data.body.password.$error},attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.data.body.password)},on:{"blur":function($event){return _vm.$v.data.body.password.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('a',{staticClass:"t-text-color form-actions__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showForgotModal = true}}},[_vm._v("\n                Forgot Password?\n              ")]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),(_vm.errorText)?_c('div',{staticClass:"error"},[_vm._v("\n          "+_vm._s(_vm.errorText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"register-link t-text-color",attrs:{"to":{name:'Signup'}}},[_vm._v("Permission Request")])],1)]),_vm._v(" "),(_vm.showForgotModal)?_c('div',{staticClass:"popup",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.showForgotModal = false}}},[_c('div',{staticClass:"popup-info"},[_c('div',{staticClass:"popup-close",on:{"click":function($event){_vm.showForgotModal = false}}},[_vm._v("×")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"popup-info__message"},[_vm._v("\n          Enter your email address and we'll send you a recovery link.\n        ")]),_vm._v(" "),(_vm.forgotSuccessText)?_c('div',{staticClass:"success"},[_vm._v("\n          "+_vm._s(_vm.forgotSuccessText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.resetSubmit()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgetData.email),expression:"forgetData.email"}],staticClass:"popup-input",class:{'is-invalid':_vm.$v.forgetData.email.$error},attrs:{"type":"email","placeholder":"Enter your email"},domProps:{"value":(_vm.forgetData.email)},on:{"blur":function($event){return _vm.$v.forgetData.email.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgetData, "email", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"popup-btn btn t-bg-color",attrs:{"type":"submit"}},[_vm._v("Send")]),_vm._v(" "),(_vm.forgotErrorText)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.forgotErrorText)+"\n          ")]):_vm._e()])])]):_vm._e()])])}
var Login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-btns-group"},[_c('button',{staticClass:"btn t-bg-color",attrs:{"type":"submit"}},[_vm._v("\n                  Login\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-info__title"},[_c('p',[_vm._v("Forgot Password?")])])}]
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var auth_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/auth/Login.vue
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = null
/* scopeId */
var Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  auth_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var components_auth_Login = (Login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Section.vue
//
//
//
//
//
//
//




/* harmony default export */ var Section = ({
  data: function data() {
    return {
      isLoaded: false,
      content: {}
    };
  },

  methods: {
    getData: function getData(slug) {
      var _this = this;

      this.isLoaded = false;
      this.axios.get('/sections/view?slug=' + slug).then(function (response) {
        _this.content = response.data.section.content;
        _this.isLoaded = true;
        document.title = response.data.section.title ? response.data.section.title + ' - ' + _this.$store.getters.settings.appName : _this.$store.getters.settings.appName;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    this.getData(this.$route.params.slug);
  },

  components: {
    appHeader: components_layout_Header,
    ContentRow: components_pages_ContentRow
  },
  watch: {
    '$route': function $route(to, from) {
      this.getData(to.params.slug);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c99d2c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Section.vue
var Section_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('section',{staticClass:"website-section content-wrapper"},[_c('app-header'),_vm._v(" "),_vm._l((_vm.content),function(row,index){return _c('content-row',{key:row.id,attrs:{"content":_vm.content,"index":index,"row":row}})})],2):_vm._e()}
var Section_staticRenderFns = []
var Section_esExports = { render: Section_render, staticRenderFns: Section_staticRenderFns }
/* harmony default export */ var pages_Section = (Section_esExports);
// CONCATENATED MODULE: ./src/components/pages/Section.vue
function Section_injectStyle (ssrContext) {
  __webpack_require__("e21Z")
}
var Section_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Section___vue_template_functional__ = false
/* styles */
var Section___vue_styles__ = Section_injectStyle
/* scopeId */
var Section___vue_scopeId__ = "data-v-9c99d2c8"
/* moduleIdentifier (server only) */
var Section___vue_module_identifier__ = null
var Section_Component = Section_normalizeComponent(
  Section,
  pages_Section,
  Section___vue_template_functional__,
  Section___vue_styles__,
  Section___vue_scopeId__,
  Section___vue_module_identifier__
)

/* harmony default export */ var components_pages_Section = (Section_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/SubSection.vue
//
//
//
//
//
//
//
//
//




/* harmony default export */ var SubSection = ({
  data: function data() {
    return {
      isLoaded: false,
      content: {},
      sectionContent: {}
    };
  },
  created: function created() {
    this.getData(this.$route.params.slug2);
  },

  components: {
    ContentRow: components_pages_ContentRow,
    appHeader: components_layout_Header
  },
  methods: {
    getData: function getData(slug2) {
      var _this = this;

      this.isLoaded = false;
      this.axios.get('/sections/view-sub?slug=' + slug2).then(function (response) {
        _this.content = response.data.subSection.content;
        _this.sectionContent = response.data.subSection.section.content;
        document.title = response.data.subSection.title ? response.data.subSection.title + ' - ' + _this.$store.getters.settings.appName : _this.$store.getters.settings.appName;
        _this.isLoaded = true;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.getData(to.params.slug2);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e203f1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/SubSection.vue
var SubSection_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',{staticClass:"website-section content-wrapper"},[_c('app-header'),_vm._v(" "),_vm._l((_vm.sectionContent),function(row,index){return _c('content-row',{key:row.id,attrs:{"content":_vm.content,"index":index,"row":row}})}),_vm._v(" "),_vm._l((_vm.content),function(row,index){return _c('content-row',{key:row.id,attrs:{"content":_vm.content,"index":index,"row":row}})})],2):_vm._e()}
var SubSection_staticRenderFns = []
var SubSection_esExports = { render: SubSection_render, staticRenderFns: SubSection_staticRenderFns }
/* harmony default export */ var pages_SubSection = (SubSection_esExports);
// CONCATENATED MODULE: ./src/components/pages/SubSection.vue
function SubSection_injectStyle (ssrContext) {
  __webpack_require__("LA/e")
}
var SubSection_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SubSection___vue_template_functional__ = false
/* styles */
var SubSection___vue_styles__ = SubSection_injectStyle
/* scopeId */
var SubSection___vue_scopeId__ = "data-v-2e203f1a"
/* moduleIdentifier (server only) */
var SubSection___vue_module_identifier__ = null
var SubSection_Component = SubSection_normalizeComponent(
  SubSection,
  pages_SubSection,
  SubSection___vue_template_functional__,
  SubSection___vue_styles__,
  SubSection___vue_scopeId__,
  SubSection___vue_module_identifier__
)

/* harmony default export */ var components_pages_SubSection = (SubSection_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Contact.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Contact = ({
  components: {
    appHeader: components_layout_Header
  },
  data: function data() {
    return {
      showModal: false,
      isLoaded: false,
      contacts: {},
      formData: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    };
  },

  validations: {
    formData: {
      name: {
        required: validators["required"]
      },
      email: {
        required: validators["required"],
        email: validators["email"]
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        var qs = __webpack_require__("mw3O");
        this.axios.post('/contacts/submit', qs.stringify(this.formData)).then(function (response) {
          if (response.data.success === 'success') {
            _this.showModal = true;
            _this.formData = {
              name: '',
              email: '',
              subject: '',
              message: ''
            };
            _this.$v.$touch();
            _this.$v.$reset();
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    getData: function getData() {
      var _this2 = this;

      this.$store.dispatch('setIsLoaded', false);
      this.isLoaded = false;
      this.axios.get('/contacts').then(function (response) {
        _this2.contacts = response.data.contacts;
        _this2.$store.dispatch('setIsLoaded', true);
        _this2.isLoaded = true;
        document.title = 'Contact Information ' + ' - ' + _this2.$store.getters.settings.appName;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    this.getData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa78a000","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Contact.vue
var Contact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('section',{staticClass:"website-section content-wrapper"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"contact-info-wrapper"},[_c('div',{staticClass:"contact-left-col"},[_c('div',{staticClass:"c-introduction"},[_c('header',{staticClass:"main-section-title"},[_c('h1',[_vm._v(_vm._s(_vm.$store.getters.settings.client.contact_page_title))])]),_vm._v(" "),_c('div',{staticClass:"body-text-wrapper"},[(_vm.$store.getters.settings.client.contact_page_body)?_c('div',{staticClass:"body-text body-text--large",domProps:{"innerHTML":_vm._s(_vm.$store.getters.settings.client.contact_page_body)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"contact-form"},[_c('form',{staticClass:"form-wrapper",on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('fieldset',[_c('legend',{staticClass:"legend-title"},[_vm._v("SYNTAX: "+_vm._s(_vm.$store.getters.settings.appName)+" brand guardians")]),_vm._v(" "),_c('p',{staticClass:"form-desc"},[_vm._v("\n              Please contact SYNTAX for advice related to the brand guidelines.\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],staticClass:"form-input",class:{'is-invalid':_vm.$v.formData.name.$error},attrs:{"type":"text","placeholder":"Name*"},domProps:{"value":(_vm.formData.name)},on:{"blur":function($event){return _vm.$v.formData.name.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.email),expression:"formData.email"}],staticClass:"form-input",class:{'is-invalid':_vm.$v.formData.email.$error},attrs:{"type":"email","placeholder":"Email*"},domProps:{"value":(_vm.formData.email)},on:{"blur":function($event){return _vm.$v.formData.email.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "email", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.subject),expression:"formData.subject"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Subject"},domProps:{"value":(_vm.formData.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "subject", $event.target.value)}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.message),expression:"formData.message"}],staticClass:"form-text-area",attrs:{"placeholder":"Your message…"},domProps:{"value":(_vm.formData.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "message", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{staticClass:"contact-right-col"},_vm._l((_vm.contacts),function(contact){return _c('div',{staticClass:"contact-card"},[(contact.name)?_c('p',{staticClass:"contact-card__info"},[_vm._v(_vm._s(contact.name))]):_vm._e(),_vm._v(" "),(contact.title)?_c('p',{staticClass:"contact-card__info"},[_vm._v(_vm._s(contact.title))]):_vm._e(),_vm._v(" "),(contact.phone)?_c('p',{staticClass:"contact-card__info t-text-color"},[_vm._v(_vm._s(contact.phone))]):_vm._e(),_vm._v(" "),(contact.email)?_c('p',{staticClass:"contact-card__info"},[_c('a',{staticClass:"t-text-color",attrs:{"href":'mailto:'+contact.email}},[_vm._v("\n            "+_vm._s(contact.email)+"\n          ")])]):_vm._e()])}),0)]),_vm._v(" "),(_vm.showModal)?_c('div',{staticClass:"popup submission"},[_c('div',{staticClass:"popup-info submission-info"},[_c('div',{staticClass:"submission-info__icon check"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('button',{staticClass:"popup-btn btn t-bg-color",on:{"click":function($event){_vm.showModal = false}}},[_vm._v("Done")])])]):_vm._e()],1):_vm._e()}
var Contact_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-actions"},[_c('a',{staticClass:"t-text-color form-actions__link"},[_vm._v("*Mandatory field.")]),_vm._v(" "),_c('div',{staticClass:"form-btns-group"},[_c('button',{staticClass:"btn default-btn"},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn t-bg-color"},[_vm._v("Send")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-info__message"},[_vm._v("\n        Thank you!\n        "),_c('br'),_vm._v("\n        Your submission will be reviewed\n      ")])}]
var Contact_esExports = { render: Contact_render, staticRenderFns: Contact_staticRenderFns }
/* harmony default export */ var pages_Contact = (Contact_esExports);
// CONCATENATED MODULE: ./src/components/pages/Contact.vue
function Contact_injectStyle (ssrContext) {
  __webpack_require__("jkRU")
}
var Contact_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Contact___vue_template_functional__ = false
/* styles */
var Contact___vue_styles__ = Contact_injectStyle
/* scopeId */
var Contact___vue_scopeId__ = "data-v-aa78a000"
/* moduleIdentifier (server only) */
var Contact___vue_module_identifier__ = null
var Contact_Component = Contact_normalizeComponent(
  Contact,
  pages_Contact,
  Contact___vue_template_functional__,
  Contact___vue_styles__,
  Contact___vue_scopeId__,
  Contact___vue_module_identifier__
)

/* harmony default export */ var components_pages_Contact = (Contact_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Downloads.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Downloads = ({
  components: {
    appHeader: components_layout_Header
  },
  data: function data() {
    return {
      isLoaded: false,
      folders: {},
      loading: false
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.$store.dispatch('setIsLoaded', false);
      this.isLoaded = false;
      this.axios.get('/downloads').then(function (response) {
        _this.folders = response.data.folders;
        _this.$store.dispatch('setIsLoaded', true);
        _this.isLoaded = true;
        document.title = 'Download Center ' + ' - ' + _this.$store.getters.settings.appName;
      }).catch(function (error) {
        console.log(error);
      });
    },
    download: function download(folder, Name) {
      var _this2 = this;

      if (this.loading === false) {
        // var windowRef = window.open()
        this.loading = folder.id;
        this.axios.get('/downloads/download?id=' + folder.id, {}).then(function (response) {
          if (response.data.url) {
            _this2.runDownload(response.data.url, Name);
            //     windowRef.location = response.data.url
            //     setTimeout(function () {
            //       windowRef.close()
            //     }, 500)
          }
        });
      }
    },
    runDownload: function runDownload(url, Name) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.axios.get(url, { responseType: 'blob' }).then(function (response) {
                  var blob = new Blob([response.data], { type: 'application/zip' });
                  var link = document.createElement('a');
                  link.href = URL.createObjectURL(blob);
                  link.download = Name;
                  link.click();
                  URL.revokeObjectURL(link.href);
                  _this3.loading = false;
                }).then(function () {
                  _this3.loading = false;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  },
  created: function created() {
    this.getData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15299c45","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Downloads.vue
var Downloads_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('section',{staticClass:"website-section content-wrapper"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"c-introduction"},[_c('header',{staticClass:"main-section-title"},[_c('h1',[_vm._v(_vm._s(_vm.$store.getters.settings.client.download_page_title))])]),_vm._v(" "),_c('div',{staticClass:"body-text-wrapper"},[_c('div',{staticClass:"body-text body-text--large",domProps:{"innerHTML":_vm._s(_vm.$store.getters.settings.client.download_page_body)}})])]),_vm._v(" "),_c('div',{staticClass:"section-block download-wrapper"},[_c('ul',{staticClass:"download-list"},_vm._l((_vm.folders),function(folder){return (folder.total_files > 0)?_c('li',{staticClass:"download-list__item"},[_c('div',{staticClass:"download-item-title"},[_c('h4',[_vm._v(_vm._s(folder.name))]),_vm._v(" "),_c('div',{staticClass:"file-details"},[_c('span',[_vm._v(_vm._s(folder.total_files)+" Files")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(folder.total_size))])])]),_vm._v(" "),_c('div',{staticClass:"download-actions"},[(folder.guideline_path)?_c('router-link',{staticClass:"t-text-color",attrs:{"to":{path:folder.guideline_path}}},[_vm._v("View\n            guideline"),_c('span',{staticClass:"view-btn"})]):_vm._e(),_vm._v(" "),(folder.zip_file)?_c('a',{staticClass:"t-text-color download-actions__downlaod",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.download(folder,folder.name)}}},[_vm._v("\n            Download\n            "),(_vm.loading === folder.id)?_c('div',{staticClass:"loader"}):_c('span',{staticClass:"download-btn"})]):_vm._e()],1)]):_vm._e()}),0)])],1):_vm._e()}
var Downloads_staticRenderFns = []
var Downloads_esExports = { render: Downloads_render, staticRenderFns: Downloads_staticRenderFns }
/* harmony default export */ var pages_Downloads = (Downloads_esExports);
// CONCATENATED MODULE: ./src/components/pages/Downloads.vue
function Downloads_injectStyle (ssrContext) {
  __webpack_require__("ImAQ")
}
var Downloads_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Downloads___vue_template_functional__ = false
/* styles */
var Downloads___vue_styles__ = Downloads_injectStyle
/* scopeId */
var Downloads___vue_scopeId__ = "data-v-15299c45"
/* moduleIdentifier (server only) */
var Downloads___vue_module_identifier__ = null
var Downloads_Component = Downloads_normalizeComponent(
  Downloads,
  pages_Downloads,
  Downloads___vue_template_functional__,
  Downloads___vue_styles__,
  Downloads___vue_scopeId__,
  Downloads___vue_module_identifier__
)

/* harmony default export */ var components_pages_Downloads = (Downloads_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Signup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Signup = ({
  computed: {
    switchPath: function switchPath() {
      return '/ar' + this.$route.path;
    }
  },
  data: function data() {
    return {
      showModal: false,
      formData: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    };
  },

  validations: {
    formData: {
      name: {
        required: validators["required"]
      },
      email: {
        required: validators["required"],
        email: validators["email"]
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        var qs = __webpack_require__("mw3O");
        this.axios.post('/signup/submit', qs.stringify(this.formData)).then(function (response) {
          if (response.data.success === 'success') {
            _this.showModal = true;
            _this.formData = {
              name: '',
              email: '',
              subject: '',
              message: ''
            };
            _this.$v.$touch();
            _this.$v.$reset();
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  },
  created: function created() {
    this.$store.dispatch('setIsLoaded', true);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27cb1798","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Signup.vue
var Signup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"login-header"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.$store.getters.settings.client.logo_2x,"srcset":_vm.$store.getters.settings.client.logo_4x +' 2x',"alt":"logo"}})]),_vm._v(" "),(_vm.$store.getters.settings.client.bilingual)?_c('a',{staticClass:"language-toggle--overlay",attrs:{"href":_vm.switchPath}},[_vm._v("عربي")]):_vm._e()]),_vm._v(" "),_c('main',{staticClass:"intro-pages-content",attrs:{"role":"main"}},[_c('section',{staticClass:"website-section website-form"},[_c('div',{staticClass:"container container--small"},[_c('form',{staticClass:"form-wrapper",on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('fieldset',[_c('legend',{staticClass:"legend-title"},[_vm._v("Request Access")]),_vm._v(" "),_c('p',{staticClass:"form-desc"},[_vm._v("\n              Please fill the form below for any requests related to the brand guidelines\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],staticClass:"form-input",class:{'is-invalid':_vm.$v.formData.name.$error},attrs:{"type":"text","placeholder":"Name*"},domProps:{"value":(_vm.formData.name)},on:{"blur":function($event){return _vm.$v.formData.name.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.email),expression:"formData.email"}],staticClass:"form-input",class:{'is-invalid':_vm.$v.formData.email.$error},attrs:{"type":"email","placeholder":"Email*"},domProps:{"value":(_vm.formData.email)},on:{"blur":function($event){return _vm.$v.formData.email.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "email", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.subject),expression:"formData.subject"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Subject"},domProps:{"value":(_vm.formData.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "subject", $event.target.value)}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.message),expression:"formData.message"}],staticClass:"form-text-area",attrs:{"placeholder":"Your message…"},domProps:{"value":(_vm.formData.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "message", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('a',{staticClass:"t-text-color form-actions__link"},[_vm._v("*Mandatory field.")]),_vm._v(" "),_c('div',{staticClass:"form-btns-group"},[_c('button',{staticClass:"btn default-btn",on:{"click":function($event){return _vm.$router.push({'name':'Login'})}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn t-bg-color"},[_vm._v("Send")])])])])])])]),_vm._v(" "),(_vm.showModal)?_c('div',{staticClass:"popup submission",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.showModal = false}}},[_c('div',{staticClass:"popup-info submission-info"},[_c('div',{staticClass:"submission-info__icon check"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"popup-btn btn t-bg-color",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.showModal = false}}},[_vm._v("Done")])])]):_vm._e()])])}
var Signup_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-info__message"},[_vm._v("\n          Thank you!\n          "),_c('br'),_vm._v("\n          Your request will be reviewed soon\n        ")])}]
var Signup_esExports = { render: Signup_render, staticRenderFns: Signup_staticRenderFns }
/* harmony default export */ var pages_Signup = (Signup_esExports);
// CONCATENATED MODULE: ./src/components/pages/Signup.vue
function Signup_injectStyle (ssrContext) {
  __webpack_require__("oVK6")
}
var Signup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Signup___vue_template_functional__ = false
/* styles */
var Signup___vue_styles__ = Signup_injectStyle
/* scopeId */
var Signup___vue_scopeId__ = "data-v-27cb1798"
/* moduleIdentifier (server only) */
var Signup___vue_module_identifier__ = null
var Signup_Component = Signup_normalizeComponent(
  Signup,
  pages_Signup,
  Signup___vue_template_functional__,
  Signup___vue_styles__,
  Signup___vue_scopeId__,
  Signup___vue_module_identifier__
)

/* harmony default export */ var components_pages_Signup = (Signup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/auth/Reset.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Reset = ({
  computed: {
    switchPath: function switchPath() {
      return '/ar' + this.$route.path;
    }
  },
  data: function data() {
    return {
      canReset: false,
      showModal: false,
      showErrorCode: false,
      errorCodeMessage: '',
      errorReset: '',
      formData: {
        userId: '',
        code: '',
        password: '',
        confirmPassword: ''
      }
    };
  },

  validations: {
    formData: {
      password: {
        required: validators["required"],
        minLength: Object(validators["minLength"])(6)

      },
      confirmPassword: {
        sameAsPassword: Object(validators["sameAs"])('password')
      }
    }
  },
  name: 'Reset',
  methods: {
    submit: function submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.formData.userId = this.$route.params.id;
        this.formData.code = this.$route.params.code;
        var qs = __webpack_require__("mw3O");
        var vm = this;
        this.axios.post('/recovery/reset', qs.stringify(this.formData)).then(function (response) {
          if (response.data.success === 'success') {
            vm.showModal = true;
            vm.formData = {
              password: '',
              confirmPassword: '',
              userId: '',
              code: ''
            };
            vm.$v.$touch();
            vm.$v.$reset();
          } else {
            vm.errorReset = response.data.message;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.formData.userId = this.$route.params.id;
    this.formData.code = this.$route.params.code;
    var qs = __webpack_require__("mw3O");
    this.axios.post('/recovery/check', qs.stringify(this.formData)).then(function (response) {
      if (response.data.success === 'success') {
        _this.canReset = true;
      } else {
        _this.canReset = false;
        _this.showErrorCode = true;
        _this.errorCodeMessage = response.data.message;
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  created: function created() {
    this.$store.dispatch('setIsLoaded', true);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf6d6dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Reset.vue
var Reset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"login-header"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.$store.getters.settings.client.logo_2x,"srcset":_vm.$store.getters.settings.client.logo_4x +' 2x',"alt":"logo"}})]),_vm._v(" "),(_vm.$store.getters.settings.client.bilingual)?_c('a',{staticClass:"language-toggle--overlay",attrs:{"href":_vm.switchPath}},[_vm._v("عربي")]):_vm._e()]),_vm._v(" "),_c('main',{staticClass:"intro-pages-content",attrs:{"role":"main"}},[_c('section',{staticClass:"website-section website-form"},[_c('div',{staticClass:"container container--small"},[(_vm.canReset)?_c('form',{staticClass:"form-wrapper",on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('fieldset',[_c('legend',{staticClass:"legend-title"},[_vm._v("Reset Password")]),_vm._v(" "),_c('p',{staticClass:"form-desc"},[_vm._v("\n              Please fill the form below to reset your password\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.password),expression:"formData.password"}],staticClass:"form-input",class:{'is-invalid':_vm.$v.formData.password.$error},attrs:{"type":"password","placeholder":"New Password*"},domProps:{"value":(_vm.formData.password)},on:{"blur":function($event){return _vm.$v.formData.password.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "password", $event.target.value)}}}),_vm._v(" "),(_vm.$v.formData.password.$error && !_vm.$v.formData.password.required)?_c('div',{staticClass:"error"},[_vm._v("Password is\n              required.\n            ")]):_vm._e(),_vm._v(" "),(_vm.$v.formData.password.$error && !_vm.$v.formData.password.minLength)?_c('div',{staticClass:"error"},[_vm._v("Password\n              must have at least "+_vm._s(_vm.$v.formData.password.$params.minLength.min)+" letters.\n            ")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.confirmPassword),expression:"formData.confirmPassword"}],staticClass:"form-input",class:{'is-invalid':_vm.$v.formData.confirmPassword.$error},attrs:{"type":"password","placeholder":"Confirm New Password*"},domProps:{"value":(_vm.formData.confirmPassword)},on:{"blur":function($event){return _vm.$v.formData.confirmPassword.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "confirmPassword", $event.target.value)}}}),_vm._v(" "),(_vm.$v.formData.confirmPassword.$error && !_vm.$v.formData.confirmPassword.sameAsPassword)?_c('div',{staticClass:"error"},[_vm._v("\n              Passwords must be identical.\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('a',{staticClass:"t-text-color form-actions__link"},[_vm._v("*Mandatory field.")]),_vm._v(" "),_c('div',{staticClass:"form-btns-group"},[_c('button',{staticClass:"btn default-btn",on:{"click":function($event){return _vm.$router.push({'name':'Login'})}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn t-bg-color"},[_vm._v("Send")])])]),_vm._v(" "),_c('p',{staticClass:"form-desc t-text-color",attrs:{"if":"errorReset!=''"}},[_vm._v(_vm._s(_vm.errorReset))])])]):_vm._e(),_vm._v(" "),(_vm.showErrorCode)?_c('div',{},[_c('form',{staticClass:"form-wrapper"},[_c('fieldset',[_c('legend',{staticClass:"legend-title"},[_vm._v("Reset Password")]),_vm._v(" "),_c('p',{staticClass:"form-desc t-text-color"},[_vm._v(_vm._s(_vm.errorCodeMessage))]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('a',{staticClass:"t-text-color form-actions__link"},[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn default-btn",on:{"click":function($event){return _vm.$router.push({'name':'Login'})}}},[_vm._v("Return")])])])])]):_vm._e()])]),_vm._v(" "),(_vm.showModal)?_c('div',{staticClass:"popup submission",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.showModal = false}}},[_c('div',{staticClass:"popup-info submission-info"},[_c('div',{staticClass:"submission-info__icon check"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"popup-btn btn t-bg-color",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$router.push({'name':'Login'})}}},[_vm._v("Login")])])]):_vm._e()])])}
var Reset_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-info__message"},[_vm._v("\n          Thank you!\n          "),_c('br'),_vm._v("\n          Your password has been changed successfully, please try login using your new password.\n        ")])}]
var Reset_esExports = { render: Reset_render, staticRenderFns: Reset_staticRenderFns }
/* harmony default export */ var auth_Reset = (Reset_esExports);
// CONCATENATED MODULE: ./src/components/auth/Reset.vue
function Reset_injectStyle (ssrContext) {
  __webpack_require__("gtPC")
}
var Reset_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Reset___vue_template_functional__ = false
/* styles */
var Reset___vue_styles__ = Reset_injectStyle
/* scopeId */
var Reset___vue_scopeId__ = "data-v-6cf6d6dc"
/* moduleIdentifier (server only) */
var Reset___vue_module_identifier__ = null
var Reset_Component = Reset_normalizeComponent(
  Reset,
  auth_Reset,
  Reset___vue_template_functional__,
  Reset___vue_styles__,
  Reset___vue_scopeId__,
  Reset___vue_module_identifier__
)

/* harmony default export */ var components_auth_Reset = (Reset_Component.exports);

// CONCATENATED MODULE: ./src/router.js












vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: components_pages_Home,
    meta: {
      auth: true
    }
  }, {
    path: '/login',
    name: 'Login',
    component: components_auth_Login,
    meta: {
      auth: false
    }
  }, {
    name: 'resetPassword',
    path: '/user/recover/:id/:code',
    component: components_auth_Reset,
    meta: {
      auth: false
    }
  }, {
    path: '/request',
    name: 'Signup',
    component: components_pages_Signup,
    meta: {
      auth: false
    }
  }, {
    path: '/contact',
    name: 'Contact',
    component: components_pages_Contact,
    meta: {
      auth: true
    }
  }, {
    path: '/download',
    name: 'Download',
    component: components_pages_Downloads,
    meta: {
      auth: true,
      title: 'Download Center'
    }
  }, {
    name: 'Section',
    path: '/:slug',
    component: components_pages_Section,
    meta: {
      auth: true
    }
  }, {
    name: 'SubSection',
    path: '/:slug/:slug2',
    component: components_pages_SubSection,
    meta: {
      auth: true
    }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new promise_default.a(function (resolve, reject) {
        setTimeout(function () {
          resolve({ selector: to.hash });
        }, 500);
      });
      // setTimeout(() => {
      //   return {selector: to.hash}
      // }, 2000)
    } else {
      return { x: 0, y: 0 };
    }
  }
}));
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store.js



vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    isLoaded: false,
    selectedSection: {},
    selectedSectionId: 0,
    settings: {
      appName: '',
      client: {
        'name': '',
        'main_color': '#ccc',
        'fail_color': '#f00'
      }
    },
    sections: {}
  },
  getters: {
    settings: function settings(state) {
      return state.settings;
    },
    sections: function sections(state) {
      return state.sections;
    },
    selectedSection: function selectedSection(state) {
      return state.selectedSection;
    },
    selectedSectionId: function selectedSectionId(state) {
      return state.selectedSectionId;
    },
    isLoaded: function isLoaded(state) {
      return state.isLoaded;
    }
  },
  mutations: {
    SET_SETTINGS: function SET_SETTINGS(state, payload) {
      state.settings = payload;
      document.styleSheets[0].insertRule('.t-bg-color,.main-menu__item--selected:before,.sub-section__title:before,.hero,.medium-editor-toolbar { background-color:' + payload.client.main_color + '!important; }', 0);
      document.styleSheets[0].insertRule('.t-text-color,.selected-item,.body-text a { color:' + payload.client.main_color + '!important; }', 0);
      document.styleSheets[0].insertRule('.loader  { border-top: 6px solid ' + payload.client.main_color + '!important; }', 0);
      vue_esm["a" /* default */].router.app.$Progress.setColor(payload.client.main_color);
      vue_esm["a" /* default */].router.app.$Progress.setFailColor(payload.client.fail_color);
    },
    SET_IS_LOADED: function SET_IS_LOADED(state, status) {
      state.isLoaded = status;
    },
    SET_SECTIONS: function SET_SECTIONS(state, sections) {
      state.sections = sections;
    }
  },
  actions: {
    setIsLoaded: function setIsLoaded(_ref, status) {
      var commit = _ref.commit;

      commit('SET_IS_LOADED', status);
    },
    getSettings: function getSettings(_ref2, payload) {
      var commit = _ref2.commit,
          state = _ref2.state,
          dispatch = _ref2.dispatch;

      vue_esm["a" /* default */].axios.get('/settings').then(function (response) {
        commit('SET_SETTINGS', response.data.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    setSettings: function setSettings(_ref3, payload) {
      var commit = _ref3.commit,
          state = _ref3.state,
          dispatch = _ref3.dispatch;

      commit('SET_SETTINGS', payload);
    },
    setSections: function setSections(_ref4, sections) {
      var commit = _ref4.commit;

      commit('SET_SECTIONS', sections);
    }
  }
}));
// EXTERNAL MODULE: ./node_modules/vuelidate/lib/index.js
var lib = __webpack_require__("ESwS");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









vue_esm["a" /* default */].router = router;
vue_esm["a" /* default */].config.productionTip = false;
vue_esm["a" /* default */].use(vue_axios_min_default.a, axios_default.a);
vue_esm["a" /* default */].axios.defaults.baseURL = "/api";
vue_esm["a" /* default */].use(lib_default.a);

vue_esm["a" /* default */].use(__webpack_require__("MLZB"), {
  auth: {
    request: function request(req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token });
    },
    response: function response(res) {
      return res.data.token;
    }
  },
  http: __webpack_require__("E/+Z"),
  router: __webpack_require__("LFDJ"),
  rolesVar: 'role',
  loginData: {
    url: 'auth',
    method: 'POST',
    redirect: '/',
    fetchUser: true
  },
  refreshData: {
    url: 'auth/refresh',
    method: 'POST',
    enabled: true,
    interval: 30
  },
  tokenDefaultName: 'syntaxGAt',
  fetchData: { url: 'user', method: 'GET', enabled: true },
  authRedirect: { name: 'Login' }
});
vue_esm["a" /* default */].use(vue_progressbar_default.a, {
  color: store.getters.settings.client.main_color,
  failedColor: store.getters.settings.client.fail_color
});

// Add a request interceptor
vue_esm["a" /* default */].axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  router.app.$Progress.start();
  return config;
}, function (error) {
  router.app.$Progress.fail();
  // Do something with request error
  return promise_default.a.reject(error);
});

// Add a response interceptor
vue_esm["a" /* default */].axios.interceptors.response.use(function (response) {
  // Do something with response data
  router.app.$Progress.finish();
  return response;
}, function (error, response) {
  if (error.response.status === 401) {
    router.replace('/login');
  }
  router.app.$Progress.fail();
  // Do something with response error
  return promise_default.a.reject(error);
});

vue_esm["a" /* default */].router.beforeEach(function (to, from, next) {
  router.app.$Progress.start();
  next();
});

vue_esm["a" /* default */].router.afterEach(function (to, from) {
  document.title = to.meta.title ? to.meta.title + ' - ' + store.getters.settings.appName : store.getters.settings.appName;
  router.app.$Progress.finish();
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App: src_App },
  data: {
    clientSettings: typeof settings !== 'undefined' ? settings : false
  },
  created: function created() {
    if (this.clientSettings) {
      this.$store.dispatch('setSettings', this.clientSettings);
    } else {
      this.$store.dispatch('getSettings');
    }
  }
});

/***/ }),

/***/ "OTzN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e21Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gtPC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jkRU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUAz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oVK6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ec8855323fa22a81e1e9.js